export default __webpack_public_path__ + "images/2536abd331c6bdf5a96645a9dd0c5652.svg";